import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { RaisedButton, GhostButton } from '@hobs/components/Buttons';
import { Formik, Form, Field } from 'formik';
import Textarea from '@hobs/components/Textarea';

class DiscussionForm extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <Formik
        initialValues={{
          message: ''
        }}
        onSubmit={this.props.onSubmit}
      >
        {({ values, handleSubmit, isSubmitting }) => (
          <Form>
            <Field
              name="message"
              component={Textarea}
              maxLength={500}
              label={t('Message')}
              placeholder={t('Request text')}
              disabled={isSubmitting}
            />
            <RaisedButton
              size="small"
              type="submit"
              disabled={values.message.length <= 0 || isSubmitting}
              onClick={event => {
                event.preventDefault();
                handleSubmit();
              }}
            >
              {t('Send')}
            </RaisedButton>
            <GhostButton
              size="small"
              type="button"
              disabled={
                this.props.markAsUnreadEnabled === false ||
                this.props.isLoading === true
              }
              onClick={this.props.onMarkUnread}
            >
              {t('Mark as unread')}
            </GhostButton>
          </Form>
        )}
      </Formik>
    );
  }
}

DiscussionForm.propTypes = {
  t: PropTypes.func,
  title: PropTypes.string,
  initials: PropTypes.string,
  onSubmit: PropTypes.func,
  onMarkUnread: PropTypes.func,
  markAsUnreadEnabled: PropTypes.bool,
  isLoading: PropTypes.bool
};

const DiscussionFormConnected = withTranslation()(DiscussionForm);
export { DiscussionFormConnected as DiscussionForm };
